import React, { useState, useEffect, useRef } from "react";
import emailjs from "emailjs-com";
import { db, collection, addDoc } from "../firebase";
import popupImage from "../assets/USEO.png";

const SERVICE_ID = "service_r8n2pam";
const TEMPLATE_ID = "template_ux5wpan";
const PUBLIC_KEY = "z6B6FSYvn-nOClTyA";

export default function AuthorityBuilderFunnel() {
  const [showPopup, setShowPopup] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const formRef = useRef();

  const onButtonClick = () => {
    const pdfUrl = "Revenue-ReadyWebsiteChecklistWoaomWebDesign.pdf";
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Revenue-ReadyWebsiteChecklistWoaomWebDesign.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const lastShown = localStorage.getItem("authorityFunnelPopupDate");
    const today = new Date().toDateString();

    if (lastShown !== today) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem("authorityFunnelPopupDate", today);
      }, 15000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(formRef.current);
      const name = formData.get("from_name");
      const email = formData.get("from_email");

      await addDoc(collection(db, "AuthorityBuilderFunnel1"), {
        name,
        email,
        timestamp: new Date(),
      });

      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY);

      setSubmitted(true);
      setTimeout(() => {
        onButtonClick();
      }, 1000);
    } catch (err) {
      console.error("Error sending email or saving data:", err);
      alert("Sorry, something went wrong. Please try again.");
    }
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
      <div className="relative bg-[#2E2D2B] shadow-xl w-full max-w-sm md:max-w-4xl flex flex-col md:flex-row rounded-lg overflow-hidden max-h-[90vh] md:max-h-full">
        <button
          onClick={() => setShowPopup(false)}
          className="absolute top-3 right-3 text-white text-3xl hover:text-[#C0A6F8] transition z-10"
          aria-label="Close"
        >
          &times;
        </button>

        <div className="flex flex-col md:flex-row w-full h-full">
          <div className="w-full md:w-1/2">
            <img
              src={popupImage}
              alt="Download Checklist"
              className="w-full h-auto object-cover md:h-full"
            />
          </div>

          <div className="p-6 w-full md:w-1/2 flex flex-col justify-center bg-[#2E2D2B] overflow-y-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-[#CFF098] italic mb-4">
              Revenue-Ready Website Checklist
            </h2>
            <p className="text-white text-sm md:text-base">
              <span className="pt-2">
                Learn everything you need for a successfull website launch, check the boxes as you completed the tasks.
              </span>
            </p>

            {!submitted && (
              <p className="text-[#CFF098] mt-2 italic text-sm md:text-base">
                Enter your name and email below and download it right away!
              </p>
            )}

            {submitted ? (
              <p className="mt-4 text-[#C0A6F8] font-medium text-sm md:text-base">
                Checklist Has Been Downloaded — Check Your Download Folder!
              </p>
            ) : (
              <form ref={formRef} onSubmit={handleSubmit} className="mt-4 flex flex-col gap-3">
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Your name"
                  className="p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F4F3E1] text-black text-sm md:text-base"
                />
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your email address"
                  className="p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F4F3E1] text-black text-sm md:text-base"
                />
                <input type="hidden" name="to_email" value="you@example.com" />
                <button
                  type="submit"
                  className="bg-[#C0A6F8] text-black px-4 py-2 rounded-lg hover:bg-[#CFF098] transition text-base"
                >
                  Get the Free Checklist
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
